export const palette = {
  green: "#3a8b38",
  yellow: "#b59626",
  grey: "#3f4141",
  background: "#1a1a1b",
  black: "#000000",
};
